<template>
  <Flex
    direction="column"
    :gap="1"
  >
    <BaseHeading icon="question-mark">
      {{ t('website_service.onboarding.next.title') }}
    </BaseHeading>
    <ul :class="$style.list">
      <li
        v-for="step in nextSteps"
        :key="step"
      >
        <BaseText>{{ step }}</BaseText>
      </li>
    </ul>
  </Flex>
</template>

<script
  setup
  lang="ts"
>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const props = withDefaults(
  defineProps<{
    newTerms?: boolean;
  }>(),
  {
    newTerms: false,
  },
);

const nextSteps = computed(() => {
  if (props.newTerms) {
    return [
      t('website_service.onboarding.next.step_1'),
      t('website_service.onboarding.next.step_2'),
      t('website_service.onboarding.next.step_2_v2'),
      t('website_service.onboarding.next.step_3_v2'),
      t('website_service.onboarding.next.step_4'),
      t('website_service.onboarding.next.step_5_v2'),
    ];
  } else {
    return [
      t('website_service.onboarding.next.step_1'),
      t('website_service.onboarding.next.step_2'),
      t('website_service.onboarding.next.step_3'),
      t('website_service.onboarding.next.step_4'),
    ];
  }
});
</script>

<style
  lang="scss"
  module
>

.list {
  margin: 0;
  padding-left: $spacing * 1.5;
}
</style>
